import React from "react"

import {useDeleteEmployeePositionMutation} from "../../../api/employeePositions"

import SmallButton from "../../../toolkits/SmallButton/SmallButton"
import CustomPopup from "../../../toolkits/CustomPopup/CustomPopup"

import {SUCCESS_CODE, ERROR_CODE} from "../../../constants/other"
import {useTranslation} from "react-i18next"


const DeletePositionPopup = ({position, setUserMessage, onSubmit, close}) => {
    const {t} = useTranslation("common")

    const [deleteEmployeePosition] = useDeleteEmployeePositionMutation()

    const handleSubmit = () => {

        deleteEmployeePosition(position.id)
            .unwrap()
            .then(() => {
                onSubmit()
                close()
                setUserMessage({message: t("Employee Position was successfully deleted!"), code: SUCCESS_CODE})
            })
            .catch(error => {
                setUserMessage({message: error.message, code: ERROR_CODE})
            })
    }

    return (
        <CustomPopup text_title={t("Do you want to delete {{position}}?", {position: position.name})} isSubtitle isAgreePopup>
            <div className="popup-bottom">
                <div className="popup-bottom-button-container">
                    <SmallButton btnType="secondary" onClick={close}> {t("Cancel").toUpperCase()} </SmallButton>
                    <SmallButton onClick={handleSubmit}> {t("Delete").toUpperCase()} </SmallButton>
                </div>
            </div>
        </CustomPopup>
    )
}

export default DeletePositionPopup
